// ---------------------------------------------------------------
// CSS
// ---------------------------------------------------------------
// eslint-disable-next-line
import css from '!style-loader!css-loader!sass-loader!./main.scss';

// ---------------------------------------------------------------
// INIT
// ---------------------------------------------------------------
import { I18n } from './modules/i18n/i18n';
import { ClientConfig } from './modules/clientConfig/clientConfig';
import { Design } from './modules/design/design';
import { Fonts } from './modules/fonts/fonts';
import { Map } from './modules/map/map';
import { Settings } from './modules/settings/settings';
import { Node } from './modules/node/node';
import { Edge } from './modules/edge/edge';
import { Store } from './store';
import { Xhr } from './modules/xhr/xhr';

// init store
const store = new Store();

// init app
const i18n = new I18n();
const clientConfig = new ClientConfig();
const design = new Design();
const fonts = new Fonts();
const settings = new Settings();
const node = new Node();
const edge = new Edge();
const map = new Map();
const xhr = new Xhr();

i18n.init();
clientConfig.init();
fonts.init();
store.init(xhr, i18n);
design.init(store, fonts);
settings.init(store, node, edge, map, i18n, fonts, design, clientConfig);
edge.init(store, settings, node, fonts, design);
node.init(store, settings, edge, i18n, fonts, design);
map.init(store, node, settings, edge, i18n);
xhr.init(store, i18n, fonts, clientConfig);
